import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { OrderReportType } from '@/shared/config';

import { getOrderReportDefaultName } from '../lib';

export const ORDER_REPORT_TYPE_TO_REQUESTED_REPORT_TYPES = {
  CBCT: [ReportType.ReportType_CBCT_GP],
  Pano: [ReportType.ReportType_Pano_GP],
  Panowings: [ReportType.ReportType_Pano_Bitewings],
  IOXRay: [ReportType.ReportType_IOXRay_GP],
  '3DStudio': [
    ReportType.ReportType_CBCT_Segmentation,
    ReportType.ReportType_CBCT_IOS_Superimposition,
  ],
  ImplantStudio: [ReportType.ReportType_StudioImplant],
  OrthoStudio: [
    ReportType.ReportType_StudioOrtho,
    ReportType.ReportType_CBCT_OrthoSlides,
  ],
  IOSSegmentation: [ReportType.ReportType_IOS_Segmentation],
  RawMeshViewer: [],
  Transcriptor: [],
} as const satisfies Record<
  OrderReportType | 'Panowings',
  readonly ReportType[]
>;

const ORDER_REPORT_TYPE_TO_PREVIEW_TEST_ID_SEGMENT: Record<
  OrderReportType | 'Panowings',
  string
> = {
  CBCT: getOrderReportDefaultName('CBCT'),
  Pano: getOrderReportDefaultName('Pano'),
  Panowings: 'Panowings',
  IOXRay: getOrderReportDefaultName('IOXRay'),
  '3DStudio': getOrderReportDefaultName('3DStudio'),
  ImplantStudio: getOrderReportDefaultName('ImplantStudio'),
  OrthoStudio: getOrderReportDefaultName('OrthoStudio'),
  IOSSegmentation: getOrderReportDefaultName('IOSSegmentation'),
  RawMeshViewer: getOrderReportDefaultName('RawMeshViewer'),
  Transcriptor: getOrderReportDefaultName('Transcriptor'),
};

export const REPORT_TYPE_TO_PREVIEW_TEST_ID_SEGMENT = Object.entries(
  ORDER_REPORT_TYPE_TO_REQUESTED_REPORT_TYPES,
).reduce<Partial<Record<ReportType, string>>>(
  (accumulator, [orderReportType, reportTypes]) => {
    reportTypes.forEach((reportType) => {
      accumulator[reportType] =
        ORDER_REPORT_TYPE_TO_PREVIEW_TEST_ID_SEGMENT[
          orderReportType as OrderReportType | 'Panowings'
        ];
    });

    return accumulator;
  },
  {},
);
